const tokenLSName = 'token'
const temporaryTokenLSName = 'temporaryToken'
const temporaryTokenTenantIdLSName = 'temporaryTokenTenantId'

// How a request picks its bearer token (see resolveRequestBearerToken):
// - main: always the primary login token (e.g. MyDetails, LoginTenant)
// - temporary: always the temporary tenant token
// - none: no token injected, request keeps its own Authorization header
export const AUTH_TOKEN_MODES = {
  main: 'main',
  temporary: 'temporary',
  none: 'none',
}

export function getBearerToken() {
  return localStorage.getItem(tokenLSName)
}

export function getTemporaryToken() {
  return localStorage.getItem(temporaryTokenLSName)
}

export function getTemporaryTokenTenantId() {
  return localStorage.getItem(temporaryTokenTenantIdLSName)
}

export function setTemporaryToken(token, tenantId) {
  if (!token || !tenantId) {
    clearTemporaryToken()
    return
  }

  localStorage.setItem(temporaryTokenLSName, token)
  localStorage.setItem(temporaryTokenTenantIdLSName, tenantId)
}

export function clearTemporaryToken() {
  localStorage.removeItem(temporaryTokenLSName)
  localStorage.removeItem(temporaryTokenTenantIdLSName)
}

// Default mode: use the temporary tenant token only while the request targets
// the tenant it was issued for; everything else falls back to the main token.
export function resolveRequestBearerToken(authTokenMode, clubId) {
  if (authTokenMode === AUTH_TOKEN_MODES.none) {
    return null
  }

  if (authTokenMode === AUTH_TOKEN_MODES.main) {
    return getBearerToken()
  }

  if (authTokenMode === AUTH_TOKEN_MODES.temporary) {
    return getTemporaryToken()
  }

  const temporaryToken = getTemporaryToken()

  if (temporaryToken && clubId && getTemporaryTokenTenantId() === clubId) {
    return temporaryToken
  }

  return getBearerToken()
}

/** Bearer token for Website Publisher API (publish/staging/delete), aligned with Requester. */
export function resolvePublisherAuthToken(clubId) {
  return resolveRequestBearerToken(undefined, clubId)
}

function decodeJwtPayload(token) {
  try {
    if (!token || typeof token !== 'string') return null
    const tokenParts = token.split('.')
    if (tokenParts.length < 2) return null

    const payloadBase64Url = tokenParts[1]
    const payloadBase64 = payloadBase64Url.replace(/-/g, '+').replace(/_/g, '/')
    const paddedPayload = payloadBase64 + '='.repeat((4 - (payloadBase64.length % 4)) % 4)
    const decodedPayload = atob(paddedPayload)

    return JSON.parse(decodedPayload)
  } catch {
    return null
  }
}

export function getCurrentUserId() {
  const payload = decodeJwtPayload(getBearerToken())
  if (!payload || typeof payload !== 'object') return null

  return (
    payload.Identity ||
    payload.identity ||
    payload.profileId ||
    payload.ProfileId ||
    payload.appUserId ||
    payload.AppUserId ||
    payload.userId ||
    payload.UserId ||
    payload.sub ||
    payload.sid ||
    payload.nameid ||
    payload.NameIdentifier ||
    payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] ||
    payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'] ||
    null
  )
}

export function setBearerToken(token) {
  if (!token) {
    localStorage.removeItem(tokenLSName)
    return
  }

  localStorage.setItem(tokenLSName, token)
}
